<template>
  <div class="agreement" :class="{ wide: isWideScreen }">
    <div class="ag-header">
      <div class="brand">元收纳</div>
      <h1 class="ag-title">用户隐私政策</h1>
      <div class="ag-meta">
        <span>生效日期：2026年8月1日</span>
      </div>
    </div>

    <div class="ag-body">
      <section class="sec">
        <h2>一、我们如何收集和使用您的信息</h2>
        <p>我们深知个人信息对您的重要性，并会尽力保护您的个人信息安全。本政策说明"元收纳"（以下简称"本应用"）在您使用服务过程中如何收集、使用、存储与保护您的信息。</p>

        <p><strong>1. 您主动提供的信息</strong></p>
        <ol class="num">
          <li>会员订阅信息：您购买会员时产生的订阅类型、订阅状态与有效期（由{{ brand }}应用内支付记录，本应用不直接存储您的支付密码或银行卡信息）；</li>
          <li>反馈与联系信息：您通过应用内反馈、客服渠道主动提交的内容与联系方式。</li>
        </ol>

        <p><strong>2. 设备与相册信息</strong></p>
        <ol class="num">
          <li>为实现照片浏览、相似照片识别与清理等核心功能，本应用会在您授权后访问您的相册与照片。照片的识别、分析主要在<strong>您的设备本地完成</strong>，不会默认上传至服务器。</li>
          <li>当您开启"备份与恢复"功能时，相关整理结果（非原始照片本身，或经您确认的备份内容）可能会上传至云端以便跨设备恢复，您可随时在设置中关闭该功能。</li>
        </ol>

        <p><strong>3. 使用数据</strong></p>
        <ol class="num">
          <li>设备信息：设备型号、操作系统版本、应用版本号；</li>
          <li>运行日志：为定位与修复问题收集的崩溃日志与性能数据；</li>
          <li>使用统计：功能使用频次等匿名化统计，用于改进产品体验。</li>
        </ol>

        <p><strong>4. 我们如何使用上述信息</strong></p>
        <ol class="circle">
          <li>提供、维护与改进本应用的核心功能；</li>
          <li>管理您的账号与会员权益；</li>
          <li>向您发送必要的服务通知（如会员到期提醒、重要更新）；</li>
          <li>分析使用情况，优化产品与服务质量。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>二、信息的存储与安全</h2>
        <ol class="num">
          <li>我们仅在为实现本政策所述目的所必需的最短时间内保留您的个人信息，法律另有规定或您另有要求的除外。</li>
          <li>我们采用符合业界标准的安全防护措施（如传输加密、访问控制）保护您的信息，防止数据遭到未经授权的访问、泄露、篡改或丢失。</li>
          <li>请您理解，互联网环境并非百分之百安全，我们将尽力采取合理措施保护您的信息，但无法保证绝对安全。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>三、信息的共享与披露</h2>
        <p>我们不会向第三方出售您的个人信息。在以下情形下，我们可能共享您的信息：</p>
        <ol class="num">
          <li>与服务提供商：为完成支付、统计分析等服务，我们可能与受保密义务约束的第三方服务商共享必要信息；</li>
          <li>业务转让：如发生合并、收购或资产转让，您的信息可能作为资产一并转移，我们会要求接收方继续受本政策约束；</li>
          <li>法律要求：根据法律法规、司法或政府主管机关的要求，我们可能被要求披露您的信息。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>四、您对个人信息的权利</h2>
        <ol class="num">
          <li>您有权访问、更正您的个人信息，并可在应用设置中管理相册授权与备份开关；</li>
          <li>您可随时撤回已授予的权限，撤回后我们将停止基于该权限的相应处理，但撤回不影响撤回前已进行的处理；</li>
          <li>如您希望删除您的个人信息或注销账号，可通过应用内反馈渠道联系我们，我们将在核实后按要求处理；</li>
          <li>法律法规规定的其他权利，我们将依法予以保障。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>五、儿童隐私</h2>
        <p>本应用主要面向成年用户。我们不会故意收集未满 14 周岁儿童的个人信息。若您是监护人并发现儿童向我们提供了个人信息，请通过下方联系方式告知我们，我们将及时删除。</p>
      </section>

      <section class="sec">
        <h2>六、第三方链接与服务</h2>
        <p>本应用可能包含指向第三方网站或服务的链接。我们不控制第三方的内容与隐私实践，建议您在使用前查阅其隐私政策。本政策仅适用于本应用。</p>
      </section>

      <section class="sec">
        <h2>七、隐私政策的变更</h2>
        <ol class="num">
          <li>我们可能根据法律法规变化或业务需要调整本政策，更新后的版本将在应用内公示并更新"生效日期"；</li>
          <li>若变更涉及重大权利义务调整，我们会通过应用内显著提示等方式通知您；</li>
          <li>您在变更生效后继续使用本应用，即视为接受更新后的隐私政策。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>八、联系我们</h2>
        <p>如您对本隐私政策有任何疑问，或希望行使上述权利，请通过以下方式联系我们：</p>
        <ol class="circle">
          <li>应用内反馈渠道：本应用"设置 - 联系我们"；</li>
          <li>电子邮件：support@capturedslr.cc</li>
        </ol>
      </section>

      <div class="ag-contact">联系我们：<a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a></div>

    </div>
  </div>
</template>

<script>
export default {
  name: "privacyPolicy",
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    isIOS() {
      const q = (this.$route && this.$route.query) || {};
      const v = (q.os || q.platform || "").toString().toLowerCase();
      return v === "ios";
    },
    brand() {
      return this.isIOS ? "苹果" : "华为";
    },
  },
};
</script>

<style scoped>
.agreement {
  background: #fff;
  text-align: left;
  color: #1f2933;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.85;
  font-size: 16px;
  margin: 0 auto;
  max-width: 860px;
  padding: 24px 16px 48px;
}
.agreement.wide {
  padding: 36px 28px 56px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.ag-header {
  background: linear-gradient(135deg, #fdba74, #fb923c);
  color: #fff;
  text-align: center;
  padding: 32px 16px 26px;
  border-radius: 10px 10px 0 0;
  margin: -24px -16px 0;
}
.agreement.wide .ag-header {
  margin: -36px -28px 0;
}
.ag-header .brand {
  font-size: 0.95rem;
  letter-spacing: 0.18em;
  opacity: 0.92;
  margin-bottom: 8px;
}
.ag-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.04em;
}
.ag-meta {
  margin-top: 12px;
  font-size: 0.9rem;
  opacity: 0.9;
}
.ag-meta .dot {
  margin: 0 10px;
  opacity: 0.6;
}
.sec {
  margin-top: 28px;
}
.sec h2 {
  font-size: 1.12rem;
  color: #fb923c;
  margin: 0 0 12px;
  padding-left: 0.6em;
  border-left: 4px solid #fb923c;
  line-height: 1.5;
}
.sec p {
  margin: 0.6em 0;
}
ol.num {
  list-style: decimal;
  padding-left: 1.6em;
  margin: 0.6em 0;
}
ol.num > li {
  margin: 0.45em 0;
  padding-left: 0.2em;
}
ol.circle {
  list-style: none;
  counter-reset: c;
  padding-left: 1.7em;
  margin: 0.6em 0;
}
ol.circle > li {
  counter-increment: c;
  position: relative;
  margin: 0.45em 0;
}
ol.circle > li::before {
  content: "（" counter(c) "）";
  position: absolute;
  left: -1.7em;
  color: #fb923c;
  font-weight: 600;
}
.ag-note {
  margin-top: 26px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.88rem;
}
.ag-contact {
  margin-top: 18px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #7c3a0e;
  font-size: 0.95rem;
  text-align: center;
}
.ag-mail {
  color: #ea580c;
  text-decoration: none;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/agreements/yuanshou-na/privacy-policy.vue